import Chart from 'chart.js/auto';

(async function () {
    Array.from(document.getElementsByClassName('price-history-chart')).forEach((chartElement) => {
        const data = JSON.parse(document.getElementById(chartElement.dataset.dataSource).textContent);

        new Chart(
            chartElement,
            {
                type: 'line',
                data: {
                    labels: data.map(row => (new Date(row.timestamp * 1000)).toLocaleString([], {
                        month: "numeric",
                        day: "numeric",
                    })),
                    datasets: [
                        {
                            label: window.NXMOD.CURRENCY_SYMBOL,
                            data: data.map(row => row.price),
                            borderColor: chartElement.dataset.chartColor,
                        }
                    ]
                },
                options: {
                    responsive: true
                }
            }
        );
    });
})();
